module.exports = __webpack_public_path__ + "static/img/bannervacantes.fe1551e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bannervacantes.jpg
// module id = 6B+F
// module chunks = 1